import Component from '../core/Component'
import { CMS, IE } from '../core/config'
import EventBus from '../core/EventBus'
import Scroll, { scrollToElement } from '../services/Scroll'
import { toggleClass } from '../utils/dom'

export const STATES = {
    OPEN: 'is-opened',
    ERROR: 'has-error',
    SELECTED: 'is-selected'
}

export const defaults = {
    group: null,
    floating: false,
    maxHeight: 100000,
    scroll: false,
    required: false,
}

export default class Dropdown extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            shadow: null,
            button: null,
            dropdown: null,
            defaultValue: null
        };

        this.hasError = false
        this.hasLabel = false
        this.isError = false

        this.defaultLabel = (this.element.dataset.default) ? this.element.dataset.default : null
    }

    prepare() {
        if (!this.ref.button || CMS) {
            return
        }

        if (this.element.querySelector('[data-value]')) {
            this.hasLabel = true
            this.element.addEventListener('change', this.handleChange)
        }

        EventBus.on('snippetArea:applied', this.handleSnippetReplace)
        EventBus.on('overlay:open', this.handleOverlayOpen)

        if (this.options.required) {
            EventBus.on('dropdown:invalid', this.handleInvalid)
        }

        this.ref.button.addEventListener('click', this.handleToggleClick)
        document.addEventListener('click', this.handleOuterClick)

        Scroll.on('resize', this.handleResize)

        this.handleResize()
        this.getItems()
        this.setLabel()
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick);
        Scroll.off('resize', this.handleResize)

        if (this.options.required) {
            EventBus.off('dropdown:invalid', this.handleInvalid)
        }

        if (this.element.querySelector('[data-value]')) {
            this.element.removeEventListener('change', this.handleChange)
        }

        EventBus.off('snippetArea:applied', this.handleSnippetReplace)
        EventBus.off('overlay:open', this.handleOverlayOpen)
    }

    handleSnippetReplace = () => {
        this.handleResize()
        this.getItems()
        this.setLabel()
    }

    handleFocus = event => {
        if (event.target.getAttribute('type') == 'checkbox' || event.target.getAttribute('type') == 'radio') {
            this.open()
        }
    }

    handleBlur = event => {
        if (this.items.indexOf(event.target.closest('label')) == this.items.length || event.target.getAttribute('type') == 'radio') {
            this.close()
        }
    }

    handleChange = event => {
        let input = event.target

        if (input.getAttribute('type') == 'radio') {
            this.close()
        }

        if (this.isError && this.options.required) {
            this.element.classList.remove(STATES.ERROR)
            this.isError = false
        }

        toggleClass(this.element, STATES.SELECTED, input.value !== this.ref.defaultValue?.value)

        this.setLabel()
    }

    handleToggleClick = event => {
        event.preventDefault()
        this.toggle()
    }

    handleOuterClick = event => {
        if (!this.element.contains(event.target) && this.options.floating) {
            this.close()
        }
    }

    handleResize = () => {
        let list = this.ref.dropdown.querySelector('[data-list]')
        this.height = (list.scrollHeight < this.options.maxHeight || (CMS || IE)) ? list.scrollHeight+10 : this.options.maxHeight

        this.ref.dropdown.setAttribute('style', `max-height: ${this.height}px`)

        if (this.ref.dropdown.querySelector('[data-component="ScrollContainer"]')) {
            this.ref.dropdown.querySelector('[data-component="ScrollContainer"]').setAttribute('style', `height: ${this.height}px`)
        }

        let errorHeight = (this.isError) ? this.element.querySelector('.form-Input-error').scrollHeight : 0

        if (this.ref.shadow) {
            this.ref.shadow.setAttribute('style', `height: ${this.element.scrollHeight + this.height}px`)
        }
    }

    handleOverlayOpen = ({ group, element }) => {
        if (!this.options.group) {
            return
        }

        if (this.options.group === group && this.element !== element) {
            this.close()
        }
    }

    handleInvalid = event => {
        this.element.classList.add(STATES.ERROR)
        this.isError = true
    }

    getItems() {
        this.items = Array.from(this.ref.dropdown.querySelectorAll('label'))
        this.items.map(($element, index) => {
            $element.addEventListener('focus', this.handleFocus, true)
            $element.addEventListener('blur', this.handleBlur, true)
            this.items[index].input = $element.querySelector('input')
        })
    }

    setLabel() {
        if (this.ref.button.querySelector('[data-value]')) {
            let label = ''

            if (this.items) {
                let checked = this.items.filter($item => {
                    if ($item.querySelector('input[type="radio"]')) {
                        return $item.querySelector('input[type="radio"]').checked
                    } else if ($item.querySelector('input[type="checkbox"]')) {
                        return $item.querySelector('input[type="checkbox"]').checked
                    }
                })

                if (!checked[0]) {
                    label = this.defaultLabel
                } else {
                    label = checked[checked.length-1].textContent

                    if (checked.length > 1) {
                        label += '...'
                    }
                }
            }

            this.ref.button.querySelector('[data-value]').innerHTML = `<span>${label}</span>`
        }
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.is(STATES.OPEN)) {
            return
        }

        this.element.classList.add(STATES.OPEN)

        EventBus.emit('overlay:open', {
            group: this.options.group,
            element: this.element
        })

        setTimeout(() => {
            EventBus.emit('dropdown:changedHeight')

            if (this.options.scroll) {
                scrollToElement(this.element, {offset: 120})
            }
        }, 100)
    }

    close() {
        if (!this.is(STATES.OPEN)) {
            return
        }

        this.element.classList.remove(STATES.OPEN)

        EventBus.emit('overlay:close', {
            group: this.options.group,
            element: this.element
        })

        setTimeout(() => {
            EventBus.emit('dropdown:changedHeight')
        }, 300)
    }
}
